import React from "react";
import { Image, type ImageProps } from "@chakra-ui/react";

export interface BrandMarkProps extends Omit<ImageProps, "src"> {
  /** "dark" → white wordmark (Logo.png) for navy surfaces; "light" → full-colour wordmark (bidfood-logo.png) for white surfaces. */
  variant?: "light" | "dark";
}

/**
 * The myBidfood wordmark with explicit height + `w="auto"` (no CLS), eager loading and a correct alt.
 * @example <BrandMark variant="dark" h="2.25rem" />   // sidebar masthead
 * @example <BrandMark variant="light" h="28px" />     // header
 */
export const BrandMark: React.FC<BrandMarkProps> = ({ variant = "dark", h = "2.25rem", alt, ...rest }) => {
  const base = process.env.PUBLIC_URL ?? "";
  const file = variant === "dark" ? "Logo.png" : "bidfood-logo.png";
  return (
    <Image
      src={`${base}/assets/${file}`}
      alt={alt ?? (variant === "dark" ? "myBidfood" : "Bidfood")}
      h={h}
      w="auto"
      loading="eager"
      draggable={false}
      {...rest}
    />
  );
};
